import React from 'react';
import { Status } from 'src/graphql/types';
import { Grey, MangoAnotherBlue, White } from 'src/styles/colours';
import { DemiBold } from 'src/styles/fonts';
import styled from 'styled-components';
import { ALL_STATUSES } from '.';
import { toDisplayStatus } from '../status-badge/status-badge';

export const CloseButton = styled.button`
  font-family: ${DemiBold};
  border: 1px solid ${Grey};
  border-radius: 3px;
  color: ${MangoAnotherBlue};
  background: transparent;
  padding: 0.75rem 2rem;
  margin-right: 0.5rem;
  cursor: pointer;
`;

export const ApplyButton = styled.button`
  font-family: ${DemiBold};
  background: ${MangoAnotherBlue};
  color: ${White};
  border-radius: 3px;
  border: none;
  padding: 0.75rem 2rem;
  cursor: pointer;
`;

export const ButtonContainer = styled.div`
  display: flex;
  margin-top: 0.5rem;
`;

export const StyledCheckbox = styled.input`
  margin-right: 1rem;
`;

export const StyledLabel = styled.label`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 0.2rem 1rem;
  cursor: pointer;
`;

export const StatusMenuPopupContents = ({
  filters,
  statusCounts,
  onToggle,
  onToggleAll,
  onApply,
  onClose,
}: {
  filters: Status[] | string[];
  statusCounts: { [key in NonNullable<Status>]: number };
  onToggle: (toggle: boolean, status: any) => void;
  onToggleAll: (toggle: boolean) => void;
  onApply: () => void;
  onClose: () => void;
}) => (
  <>
    <StyledLabel>
      <StyledCheckbox
        type="checkbox"
        data-type="filter-option"
        data-value="ALL"
        checked={filters.length === ALL_STATUSES.length}
        onChange={e => {
          return onToggleAll(e.target.checked);
        }}
      />
      (Select all)
    </StyledLabel>
    {ALL_STATUSES.map(status => (
      <div key={status}>
        <StyledLabel>
          <StyledCheckbox
            type="checkbox"
            data-type="filter-option"
            data-value={status}
            checked={filters.includes(status)}
            onChange={e => {
              return onToggle(e.target.checked, status);
            }}
          />
          {toDisplayStatus(status)} ({statusCounts[status]})
        </StyledLabel>
      </div>
    ))}
    <ButtonContainer>
      <CloseButton onClick={onClose}>Close</CloseButton>
      <ApplyButton onClick={onApply} data-type="apply-button">
        Apply
      </ApplyButton>
    </ButtonContainer>
  </>
);
